// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3nV5Q","actionsCol":"EnrolledClinics_actionsCol__2iAwg"};